import { useState } from "react";
import { Box, Button, Fab, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Link } from "react-router-dom";

import { useDebounce } from "use-debounce";
import SearchBox from "../SearchBox";
import useIsLargeScreen from "../../hooks/useIsLargeScreen";
import SkillsTable from "./SkillsTable";
import { useAppPaths } from "../../Routes";

const SkillsTableWithSearch = () => {
    const theme = useTheme();
    const isLargeScreen = useIsLargeScreen();
    const appPaths = useAppPaths();
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [debounceSearchTerm] = useDebounce(searchTerm, 700);

    return (
        <>
            <Box sx={{
                display: "flex",
                alignItems: "center",
                marginTop: theme.spacing(3),
                justifyContent: "space-between",
                "& > *:not(:first-of-type)": {
                    marginLeft: 1,
                },
            }}>
                <SearchBox
                    placeholder="Search by Name"
                    onChange={setSearchTerm}
                    searchTerm={searchTerm}
                    sx={isLargeScreen ? { minWidth: "28rem", background: "#FFFFFF" } : { flexGrow: 1, background: "#FFFFFF" }}
                />
                {isLargeScreen && (
                    <Link to={appPaths.skills.create} style={{ textDecoration: "none", outline: "none", marginLeft: "1.25rem" }}>
                        <Button
                            size="medium"
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                        >
                            Create
                        </Button>
                    </Link>
                )}
            </Box>
            <Box sx={{ marginTop: "1.5rem" }}>
                <SkillsTable
                    searchTerm={debounceSearchTerm}
                />
            </Box>
            {!isLargeScreen && (
                <Link to={appPaths.skills.create}>
                    <Fab
                        color="primary"
                        aria-label="create-skill"
                        sx={{
                            position: "fixed",
                            bottom: theme.spacing(10),
                            right: theme.spacing(4),
                        }}
                    >
                        <AddIcon fontSize="large" />
                    </Fab>
                </Link>
            )}
        </>
    );
};
export default SkillsTableWithSearch;